import React, { useState } from 'react';

import { useAnalyticsContext } from 'app/shared/utils';
import { useKlaviyoEmailAndSmsPopup } from 'app/shared/utils/useKlaviyoEmailAndSmsPopup';
import {
  AuthFormContextProvider,
  MultiStepSignUpContextProvider,
} from 'app/shared/context';
import { Responsive } from 'app/shared/components/atoms';
import { Box } from 'app/shared/components/atoms';
import { useEventPageContext } from 'app/fan/context/EventPage';
import { Drawer } from 'app/fan/components/molecules';
import { EventPageTemplate } from 'app/fan/components/templates';
import {
  CheckoutWidget,
  EventCTAWidget,
} from 'app/fan/components/pages/Event/components';
import { useTrackProductViewed } from 'app/fan/components/pages/Event/eventUtils';

import { SmsSignUpModal } from './SmsSignUpModal';

interface Props {
  'data-qaid'?: string;
}

export const BuyFlowPrePurchaseContainer: React.FC<
  React.PropsWithChildren<Props>
> = ({ 'data-qaid': dataQaid = 'event-page-buy-flow-pre-purchase' }) => {
  const { event } = useEventPageContext();
  const [displayCheckoutSection, setDisplayCheckoutSection] = useState(false);
  const { trackAnalyticsEvent } = useAnalyticsContext();

  useTrackProductViewed();
  useKlaviyoEmailAndSmsPopup();

  // We will never run into this scenario, but include this code so that
  // Typescript knows to expect this to be present
  if (!event) {
    return null;
  }

  function openCheckoutDrawer() {
    trackAnalyticsEvent('Checkout Drawer Opened', {
      user_has_tickets: false,
      event_id: event?.id,
    });
    setDisplayCheckoutSection(true);
  }

  function onDrawerClose() {
    trackAnalyticsEvent('Checkout Drawer Closed', {
      user_has_tickets: false,
      event_id: event?.id,
    });
  }

  return (
    <EventPageTemplate
      data-qaid={dataQaid}
      event={event}
      isOutOfStock={false}
      ticketSaleStatus="available"
      secondColumn={<CheckoutWidget />}
    >
      <Box data-qaid="event-page-first-column-children">
        <AuthFormContextProvider
          isPlusOneFlow={false}
          isCompleteSignUpFlow={true}
          isCheckoutAuth={false}
        >
          <MultiStepSignUpContextProvider>
            <SmsSignUpModal event={event} sofarStarted={false} />
          </MultiStepSignUpContextProvider>
        </AuthFormContextProvider>
        <EventCTAWidget
          event={event}
          eventAttendeeExists={false}
          isBuyTicketsCTAEnabled={true}
          onClickGetTickets={openCheckoutDrawer}
          isDrawerOpen={displayCheckoutSection}
          maxTicketsBought={false}
        />
        <Responsive hideUp="smallDesktop">
          <Drawer
            isOpen={displayCheckoutSection}
            setIsOpen={setDisplayCheckoutSection}
            onClose={onDrawerClose}
          >
            <CheckoutWidget />
          </Drawer>
        </Responsive>
      </Box>
    </EventPageTemplate>
  );
};
